import { AlertNotificationsState } from '../store/alertNotifications';
import { useAppSelector } from './store';

export const useAlertNotifications = () => {
  return useAppSelector<AlertNotificationsState>((state) => state.alertNotifications).notifications;
};
